module.exports = __webpack_public_path__ + "images/2a6873fdab6294e4a5f21f5b9641fd36.jpg";